// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router';
import MobileHome from '../views/Mobile.vue';
import Index from '../views/Home.vue';
import Home from '../views/Home2.vue';
import RoundTrays from '../views/RoundTrays.vue';
import RoundTray from '../views/RoundTray.vue';
import CamtreadTray from '../views/CamtreadTray.vue';
import RectangularTrays from '../views/RectangularTrays.vue';
import RectangularEpictreadTrayBoth from '../views/RectangularEpictreadTrayBoth.vue';
import EpictreadTray from '../views/EpictreadTray.vue';
import RectangularTray from '../views/RectangularTray.vue';
import FastfoodTray from '../views/FastfoodTray.vue';
import TrapezoidTray from '../views/TrapezoidTray.vue';
import CompartmentTrays from '../views/CompartmentTrays.vue';
import CompartmentTray from '../views/CompartmentTray.vue';
import CompartmentRoundTray2 from '../views/CompartmentRoundTray2.vue';
import Quote from '../views/Quote.vue';
import Drag from '../views/drag.vue';
import IntroAnimation from '../views/IntroAnimation.vue';

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/mobile',
    name: 'MobileHome',
    component: MobileHome
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/round-trays',
    name: 'RoundTrays',
    component: RoundTrays
  },
  {
    path: '/rectangular-trays',
    name: 'RectangularTrays',
    component: RectangularTrays
  },
  {
    path: '/round-tray',
    name: 'RoundTray',
    component: RoundTray
  },
  {
    path: '/camtread-tray',
    name: 'CamtreadTray',
    component: CamtreadTray
  },
  {
    path: '/rectangular-epictread-tray',
    name: 'RectangularEpictreadTrayBoth',
    component: RectangularEpictreadTrayBoth
  },
  {
    path: '/epictread-tray',
    name: 'EpictreadTray',
    component: EpictreadTray
  },
  {
    path: '/rectangular-tray',
    name: 'RectangularTray',
    component: RectangularTray
  },
  {
    path: '/fastfood-tray',
    name: 'FastfoodTray',
    component: FastfoodTray
  },
  {
    path: '/trapezoid-tray',
    name: 'TrapezoidTray',
    component: TrapezoidTray
  },
  {
    path: '/compartment-trays',
    name: 'CompartmentTrays',
    component: CompartmentTrays
  },
  {
    path: '/compartment-tray',
    name: 'CompartmentTray',
    component: CompartmentTray
  },
  {
    path: '/compartment-round-tray',
    name: 'CompartmentRoundTray2',
    component: CompartmentRoundTray2
  },
  {
    path: '/quote',
    name: 'Quote',
    component: Quote
  },
  {
    path: '/intro-animation',
    name: 'IntroAnimation',
    component: IntroAnimation
  },
  {
    path: '/drag',
    name: 'Drag',
    component: Drag
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Design Your Cambro Tray';
  next();
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  next();
});


export default router;
